/**
 * Navigation Backdrop
 * Shows Bootstrap 5 modal backdrop when navbar dropdowns are triggered
 */

(function () {
    'use strict';

    let backdrop = null;

    /**
     * Show the backdrop using Bootstrap's CSS classes
     */
    function showBackdrop() {
        if (!backdrop) {
            // Create backdrop with Bootstrap's modal-backdrop classes
            backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade';
            backdrop.style.zIndex = '1040'; // Below modals (1055) but above navbar
            document.body.appendChild(backdrop);

            // Add modal-open class to body to prevent scrolling
            document.body.classList.add('modal-open');

            // Trigger fade-in animation
            requestAnimationFrame(() => {
                backdrop.classList.add('show');
            });

            // Close dropdowns when clicking the backdrop
            backdrop.addEventListener('click', hideAllDropdowns);
        }
    }

    /**
     * Hide the backdrop
     */
    function hideBackdrop() {
        if (backdrop) {
            backdrop.classList.remove('show');
            // Remove modal-open class from body
            document.body.classList.remove('modal-open');
            // Wait for Bootstrap's fade transition to complete
            setTimeout(() => {
                if (backdrop && backdrop.parentNode) {
                    backdrop.remove();
                }
                backdrop = null;
            }, 150); // Bootstrap's default transition duration
        }
    }

    /**
     * Hide all open dropdowns and close mobile menu
     */
    function hideAllDropdowns() {
        const dropdowns = document.querySelectorAll('.navbar .dropdown-menu.show');
        dropdowns.forEach(dropdownMenu => {
            const toggle = dropdownMenu.previousElementSibling;
            if (toggle) {
                const bsDropdown = bootstrap.Dropdown.getInstance(toggle);
                if (bsDropdown) {
                    bsDropdown.hide();
                }
            }
        });

        // Also close the mobile navbar collapse
        const navbarCollapse = document.querySelector('.navbar-collapse.show');
        if (navbarCollapse) {
            const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
            if (bsCollapse) {
                bsCollapse.hide();
            }
        }
    }

    /**
     * Initialize backdrop functionality for navbar dropdowns
     */
    function init() {
        // Target elements that have data-bs-toggle="dropdown" in the navbar
        const navbarDropdowns = document.querySelectorAll('.navbar [data-bs-toggle="dropdown"]');

        navbarDropdowns.forEach(dropdownToggle => {
            // Listen to Bootstrap's dropdown events
            dropdownToggle.addEventListener('show.bs.dropdown', function () {
                showBackdrop();
            });

            dropdownToggle.addEventListener('hide.bs.dropdown', function () {
                // Check if any other dropdowns are still open after a short delay
                setTimeout(() => {
                    const openDropdowns = document.querySelectorAll('.navbar .dropdown-menu.show');
                    const openCollapse = document.querySelector('.navbar-collapse.show');
                    if (openDropdowns.length === 0 && !openCollapse) {
                        hideBackdrop();
                    }
                }, 10);
            });
        });

        // Target the mobile navbar collapse
        const navbarCollapse = document.querySelector('.navbar-collapse');
        if (navbarCollapse) {
            navbarCollapse.addEventListener('show.bs.collapse', function () {
                showBackdrop();
            });

            navbarCollapse.addEventListener('hide.bs.collapse', function () {
                // Check if any dropdowns are still open after a short delay
                setTimeout(() => {
                    const openDropdowns = document.querySelectorAll('.navbar .dropdown-menu.show');
                    if (openDropdowns.length === 0) {
                        hideBackdrop();
                    }
                }, 10);
            });
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
